import Cookies from 'js-cookie';
import { externalSourcesBanner } from './ExternalSourcesBanner';

// Flipbook consent
if (!Cookies.get('AllowExternalServices')) {
  const flipBooks = Array.from(document.querySelectorAll('.dflip-wrapper'));
  flipBooks.length && flipBooks.forEach(book => {
    externalSourcesBanner(book, 'pdf');
  });
}
